import {UUID} from '../../../shared/types/uuid.type';
import { createAction, props } from '@ngrx/store';

const prefix = '[DeleteManyMultiviews] ';

export const deleteManyMultiviews = createAction(
  `${prefix} Delete Many Multiviews`,
  props<{ ids: UUID[] }>()
);

export const deleteManyMultiviewsSuccess = createAction(
  `${prefix} Delete Many Multiviews Success`,
  props<{ ids: UUID[] }>()
);

export const deleteManyMultiviewsFailure = createAction(
  `${prefix} Delete Many Multiviews Failure`,
  props<{ error: any }>()
);

export const clearDeleteManyMultiviewsState = createAction(
  `${prefix} Clear Delete Many Multiviews State`,
);
